import {
    ActionItem,
    ActionItemStyle,
    AsyncEllipsisMultiActionItem,
    EllipsisMultiActionItem,
    OpenDirection
} from '@stylehaven/components';
import { Observable } from 'rxjs';

export function MoreActionsButton(actions: ActionItem[], disabledInfoMsg: string = ''): ActionItem {
    return EllipsisMultiActionItem(
        actions,
        false,
        ActionItemStyle.PureIconButton,
        OpenDirection.LeftOverlap,
        disabledInfoMsg
    );
}

export function AsyncMoreActionsButton(
    actions: Observable<ActionItem | null>[],
    disabledInfoMsg: string = ''
): ActionItem {
    return AsyncEllipsisMultiActionItem(
        actions,
        false,
        ActionItemStyle.PureIconButton,
        OpenDirection.LeftOverlap,
        disabledInfoMsg
    );
}
